import { Text } from 'components/Text'
import styled from 'styled-components'

export const PastPurchaseContainer = styled.div`
  margin-top: 50px;
  padding-left: 30px;
  padding-right: 48px;
`

export const PastPurchaseItemText = styled(Text)`
  font-weight: 500;
  font-size: 1rem;
  line-height: 1rem;
`

export const PastPurchaseModalContent = styled.div`
  margin: 25px 0;
`

export const PastPurchaseModalDes = styled.p``

export const PastPurchaseModalFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`
